// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import qs from 'qs'
import axios from 'axios'
import Global from '../static/config/global'
import cookie from 'js-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import jsrsasign from 'jsrsasign'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.GLOBAL = Global
Vue.prototype.Cookie = cookie

axios.interceptors.request.use(function (config) {
  let userInfo = {}
  if (!config.url.includes('/user/auth') && !config.url.includes('/time') && !config.url.includes('/getQrLoginCode') && !config.url.includes('/wechat/checkQrLogin')) {
    if (cookie.get('userInfo') === undefined || cookie.get('userInfo') === '') {
      if (router.currentRoute.path !== '/login') {
        router.push('login')
        return
      }
    }
    userInfo = JSON.parse(cookie.get('userInfo'))
    if (userInfo == null || userInfo.id == null || userInfo.pcLoginKey == null) {
      if (router.currentRoute.path !== '/login') {
        router.push('login')
        return
      }
    }
  }
  var k = `-----BEGIN PRIVATE KEY-----
MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAMQdOy8b6YmnzETF
K+uxcXNeyGA7JD82SAhbnppOG/n/KOAzW1Sbec1GzwEDcwNHy6qZeT+Ql8b0x3O8
1ZYqMYaP3uC9rB5LckpHdur//hyukjLJkFFoJoO7ElCJtalNmQS1pXYz8fGbW9nj
6ebITR1J/h2lzhD5KiFMaSAYQ4zbAgMBAAECgYAqwLCZSX106+alC1LS0+EGpKAM
EniJazzyzX5a5zJEIrL3hVqgrDA2ZvxTnTvieDFXJJQBHnVoAw7EFWN+k/4tlNVM
DE8EikFVJzyOOvZ3y68i5yZE9wYPdgXIODP37oAP/Wy+DCR46ZJue4ViCeEnDuQ3
z9mdTRLJRy+nfNBFcQJBAONygatU3MX9speeQO/pxVppoWjewgq6A5HSK4rseA7M
38CbeSLdvfwSAEqBy4MytADSJHI3wvat3ikKQAr6yckCQQDcu8UWjOyZ5xDXQQxo
VTpaG8yqHrwVf7x9qOQc8G5kca794KkIExb4TQVEZ3y9wx0vho5jh3KaykXKY5yL
gXODAkEAjUqs0so8+6HGN/nPTTpjpu7HnmYDFLbJUOTGt95+FnOe6/+pGMe3Jcfo
9l/7FN2ChKAGlA2fx63qvIPplOiGQQJBAM5//6bUGfj1GWU3HqNwsFFiVnsEm9LF
GJK6cQW9zJi9Xgd2qMu8CC4s5/ORmTpyEZjHmef07DtxZg8sV2SPq38CQBP7nonY
px+7s01eRdEFmb+EbWoXIGSEqg68yVv48UC1SMgzwMo4eb0qt9xYIRW12FgAFI5Y
3XdCcpVLBZ6Vv2Y=
-----END PRIVATE KEY-----`
  let privateKey = jsrsasign.KEYUTIL.getKey(k)
  var head = JSON.stringify({
    'typ': 'JWT',
    'alg': 'RS256'
  })
  var now = Math.round(new Date().getTime() / 1000)
  if (cookie.get('offsetSecond') !== undefined || cookie.get('offsetSecond') !== '') {
    now += parseInt(cookie.get('offsetSecond'))
  }
  let payload = JSON.stringify({
    'userId': !config.url.includes('/user/auth') ? userInfo.id : '',
    'pcLoginKey': !config.url.includes('/user/auth') ? userInfo.pcLoginKey : '',
    'nbf': now - 5,
    'exp': now + 60
  })
  // console.log('now: ' + now)
  var token = jsrsasign.KJUR.jws.JWS.sign('RS256', head, payload, privateKey)
  config.headers.token = token
  return config
})

axios.interceptors.response.use(function (response) {
  if (response != null && response.data.status != null && response.data.status === 501 && router.currentRoute.path !== '/login') {
    router.push('login')
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})

Vue.use(ElementUI)
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js